import React, { Suspense } from "react";

import { BrowserRouter } from "react-router-dom";
import { Switch, Route } from "react-router";

import ErrorBoundary from "./ErrorBoundary";
import PrivateRoute from "./PrivateRoute";
import { CurrentUserProvider } from "./useCurrentUser";
import { GoogleMapProvider } from "./useGoogleMap";
import Main from "./Main";
import Store from "./Store";
import Alert from "./Alert";
import Loader from "./Loader";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import "../index.css";

const theme = createTheme({
  palette: {
    secondary: {
      main: green[500],
    },
  },
});

export default function App() {
  let [tick, setTick] = React.useState(0);

  let tickFun = () => {
    setTick(tick + 1);
  };

  Store.onUpdate(tickFun);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <GoogleMapProvider>
          <CurrentUserProvider>
            <>
              {Store.data.error && (
                <div className="absolute flex justify-center w-full">
                  <Alert error={Store.data.error} />
                </div>
              )}
              <BrowserRouter>
                <Route path="/">
                  <Main />
                </Route>
              </BrowserRouter>
            </>
          </CurrentUserProvider>
        </GoogleMapProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
